import "../About/About.css";
import Main from "./Main/Main";
import Image from "./Image/Image";

const About = () => {
  return (
    <div className="secondPage" id="aboutme">
      <Image />
      <Main />
    </div>
  );
};

export default About;
